
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.415 18.22a.92.92 0 00.666.277c.533 0 .933-.4.933-.933a.974.974 0 00-.266-.666L3.283 9.597l7.465-7.301a.994.994 0 00.266-.667.92.92 0 00-.933-.943.92.92 0 00-.666.277L1.293 8.91a.9.9 0 00-.307.687c0 .256.102.492.297.687l8.132 7.936z","fill":"#2E7CF6"}})])
          )
        }
      }
    